import {ImpactPointTypes} from '@shared/enums/impact-point-types.enum';

export class ImpactPointModel {
	damage_to_vehicle: string;
	incident_description: string;
	detections_impact_point: ImpactPointTypes[];

	constructor() {
		this.detections_impact_point = [];
	}
}
